// src/pages/EditProfile.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db, storage } from "../utils/firebaseconfig";
import { updateProfile } from "firebase/auth";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import "../styles/addProduct.css";

function EditProfile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    bio: "",
    profilePic: ""
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        const userDoc = await getDoc(doc(db, "User", currentUser.uid));
        if (userDoc.exists()) {
          const data = userDoc.data();
          setFormData({
            username: data.username || "",
            email: data.contact?.email || currentUser.email,
            bio: data.bio || "",
            profilePic: data.profilePic || ""
          });
        }
      } else {
        navigate("/login");
      }
    });
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let photoURL = formData.profilePic;

      if (selectedFile) {
        const fileRef = ref(storage, `profilePics/${user.uid}/${selectedFile.name}`);
        await uploadBytes(fileRef, selectedFile);
        photoURL = await getDownloadURL(fileRef);
      }

      await updateDoc(doc(db, "User", user.uid), {
        username: formData.username,
        bio: formData.bio,
        profilePic: photoURL,
        contact: {
          email: formData.email
        }
      });

      await updateProfile(user, { displayName: formData.username });

      navigate("/MyAccount");
    } catch (error) {
      console.error("Error updating profile:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-product-container">
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
        </div>
      )}
      <h2 className="form-title">Edit Profile</h2>
      <form onSubmit={handleSubmit} className="add-product-form">
        <div className="form-group">
          <label>Username:</label>
          <input type="text" name="username" value={formData.username} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Email:</label>
<input type="email" name="email" value={formData.email} readOnly style={{ backgroundColor: "#f0f0f0", cursor: "not-allowed" }} />
        </div>

        <div className="form-group">
          <label>Bio:</label>
          <textarea name="bio" value={formData.bio} onChange={handleChange} />
        </div>

        <div className="form-group">
          <label>Profile Picture:</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {formData.profilePic && (
            <img src={formData.profilePic} alt="Preview" style={{ width: "100px", marginTop: "10px", borderRadius: "50%" }} />
          )}
        </div>

        <button type="submit" className="add-product-button">Update Profile</button>
      </form>
    </div>
  );
}

export default EditProfile;
